module.exports = __webpack_public_path__ + "img/icon-pauses.8f5c540a.svg";